<template>
  <div>
    <a-row>
      <g-master name="competencies"
                :endpoint="competenciasMaster.endpoint"
                :tableSetup="competenciasMaster.tableSetup"
                :modalFieldsSetup="competenciasMaster.modalFieldsSetup"
                :parentData="coParentData"
                :actions="competenciasMaster.actions"
      >

        <template slot="masterModal" slot-scope="{record}">

          <a-row :gutter="[16, 16]">

            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Definición: ">
                <a-input
                  v-decorator="['definition', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Descripción: ">
                <a-input
                  v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Alias: ">
                <a-input
                  v-decorator="['nick_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Nombre corto: ">
                <a-input
                  v-decorator="['short_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Nombre de icono: ">
                <a-input
                  v-decorator="['icon_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" label="Activo" :has-feedback="false">
                <a-checkbox v-decorator="['status', {valuePropName: 'checked'}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="type_competency"
                          label="Tipo de competencia: "
                          :formItemConfig="fiOptions"
                          :decorator="['id_type_competency',{ rules: [{ required: false, message: 'Valor requerido' }]}]">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="COMPORTAMIENTO" key="1">
          <comportamiento v-if="idCompetencias" :id_competency="idCompetencias" :dateInitial="dateInitial"></comportamiento>
          <span v-else>Seleccione una evaluación para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_evaluation', 'dateInitial'],
    mounted () {
      let now = moment().format('Y-MM-DD')
      if (this.dateInitial >= now) {
        this.competenciasMaster.tableSetup.actions.actions[0] =
        {
          name: 'masterEdit',
          text: 'Editar',
          permisos: [],
          props: {size: 'small', type: 'link', icon: 'edit'}
        }
        this.competenciasMaster.tableSetup.actions.actions[1] = {
          name: 'masterDelete',
          text: 'Eliminar',
          permisos: [],
          props: {size: 'small', icon: 'delete', type: 'link'}
        }
        this.competenciasMaster.actions[0] = {
          name: 'masterCreate',
          text: 'Crear',
          permisos: [],
          props: {icon: 'plus', type: 'button'}
        }
      }
    },
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 12},
          'has-feedback': true
        },
        competenciasMaster: {
          actions: [],
          endpoint: 'competency',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_competency'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Definición', dataIndex: 'definition', sorter: true},
              {title: 'Tipo de competencia', dataIndex: 'description_desc', sorter: true},
              {title: 'Alias', dataIndex: 'nick_name', sorter: true},
              {title: 'Nombre corto', dataIndex: 'short_name', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true},
              {title: 'Nombre de icono', dataIndex: 'icon_name', sorter: true}
            ],
            allowSelect: true,
            selectedRows: [],
            actions: {
              actions: []
            }
          },
          modalFieldsSetup: [
            {name: 'definition'},
            {name: 'description'},
            {name: 'icon_name'},
            {name: 'id_type_competency'},
            {name: 'nick_name'},
            {name: 'short_name'},
            {name: 'status'},
            {name: 'icon_name'}
          ]
        }
      }
    },
    computed: {
      coParentData () {
        return {
          id_evaluation: this.id_evaluation
        }
      },
      idCompetencias () {
        return this.competenciasMaster.tableSetup.selectedRows.length > 0 ? this.competenciasMaster.tableSetup.selectedRows[0].id_competency : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Competencias.vue